// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"c92e5c33","92":"690f019d","99":"cfcc3229","215":"c38d247b","337":"02619c3c","443":"389aeac7","479":"79beb03e","531":"e5550737","952":"71967fbd"}[chunkId] + ".chunk.js";
};